import { Link, useLocation } from '@remix-run/react'
import { useMemo } from 'react'

import { makeShopOwnPath } from '~/helpers/routes'
import { useShop } from '~/hooks/data/use-shop'

interface ShopLinkProps extends React.ComponentPropsWithoutRef<typeof Link> {
  to: string
}

export const ShopLink = ({ to, children, ...props }: ShopLinkProps) => {
  const shop = useShop()
  const location = useLocation()
  const path = useMemo(() => makeShopOwnPath(shop, to), [to, shop])

  const isCurrentPage = useMemo(() => {
    return location.pathname === path
  }, [location.pathname, path])

  return (
    <Link to={path} data-current-page={isCurrentPage} {...props}>
      {children}
    </Link>
  )
}
